import { useContext } from "react";
import { GlobalContext } from "./context/GlobalContext";
import Events from "./Events";

export default function Dashboard() {
  const { globalState } = useContext(GlobalContext);

  if (globalState.loading) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <h1 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 p-8">
        {globalState.user?.name || globalState.vendor?.name}'s Dashboard
      </h1>
      <div className="space-y-12">
        <Events />
      </div>
    </div>
  );
}
